type DocumentReference = {
  documentId: string;
  documentIndex: DocumentIndexType;
  chunkId: string;
  userId: string;
  title: string;
  localIds: string[];
  boundingBoxes?: BoundingBox[];
  htmlIds?: string[];
  activatedOn?: Date;
  documentTitle: string;
  documentType: string;
  isActive?: boolean;
  source: string;
  referenceId: number;
  workspaceId?: string;
};

export type BoundingBox = {
  page: number;
  x0: number;
  y0: number;
  x1: number;
  y1: number;
};

export enum DocumentIndexType {
  Document = "Document",
  Retsinformation = "Retsinformation",
  Workspace = "Workspace",
}
export enum DocumentIndexTypeValue {
  Document = 0,
  Retsinformation = 1,
  Workspace = 2,
}

export const normalizeDocumentIndex = (
  documentIndex: string | number
): DocumentIndexType | null => {
  if (typeof documentIndex === "string") {
    return documentIndex as DocumentIndexType;
  }

  switch (documentIndex) {
    case DocumentIndexTypeValue.Retsinformation:
      return DocumentIndexType.Retsinformation;
    case DocumentIndexTypeValue.Document:
      return DocumentIndexType.Document;
    case DocumentIndexTypeValue.Workspace:
      return DocumentIndexType.Workspace;
    default:
      return null;
  }
};

export default DocumentReference;
